import { createBrowserRouter } from "react-router-dom";
import { ChatbotProvider } from "./provider/chatbot_provider";
import Chatbot from "./views/chatbot";
import Landing from "./views/landing";
import Test from "./views/test";
import LoginScreen from "./components/LoginScreen/LoginScreen";

const router = createBrowserRouter([
  {
    path: "/",
    element: <LoginScreen />,
    // element: <Landing />,
  },
  {
    path: "/alembic-ask-tara",
    element: (
      <ChatbotProvider tool={"ai"}>
        <Chatbot tool="AI Assistant" />
      </ChatbotProvider>
    ),
  },
  {
    path: "/competitor-analysis",
    element: (
      <ChatbotProvider tool={"competitor"}>
        <Chatbot tool="Competitor Analysis" />
      </ChatbotProvider>
    ),
  },
  {
    path: "/product-catalog",
    element: (
      <ChatbotProvider tool={"catalog"}>
        <Chatbot tool="Product Catalogue" />
      </ChatbotProvider>
    ),
  },
  {
    path: "/test",
    element: <Test />,
  },
]);

export default router;
